import citiesApi from "../../api/cities";
import { latLng } from "leaflet";

const state = () => ({
  queried: false,
  cities: []
});

const getters = {
  all: state => () => state.cities,
  byId: state => cityId => state.cities.find(v => v._id === cityId)
};

const actions = {
  fetchAll({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.queried) {
        resolve();
      } else {
        citiesApi
          .getAll()
          .then(cities => {
            commit("setCities", cities);
            resolve();
          })
          .catch(e => reject(e));
      }
    });
  }
};

const mutations = {
  setCities(state, cities) {
    state.queried = true;

    for (let city of cities) {
      city.location.latLng = latLng(city.location.lat, city.location.lng);
      delete city.location.lat;
      delete city.location.lng;
    }
    state.cities = cities;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
